import { TipoCurso } from '../../../../../types';
import { Modalidade } from '../../../../usuario';
import { Brand, Domain } from '../../../config.types';

export interface CalendarioAcademico {
  titulo: string;
  url: string;
}

export enum OpcoesAjuda {
  FAQ = 'FAQ',
  MANUAL = 'MANUAL',
  NAAP = 'NAAP',
}

// ???? baguncinha aqui
export interface Ajuda {
  titulo: string;
  url: string;
  tagGA: string;
  modalidade?: Modalidade;
  tipo: OpcoesAjuda;
}

export interface BibliotecaVirtual {
  title: string;
  url: string;
  descricao: string;
}

export interface OnboardingPlataforma {
  slides: SlideOnboarding[];
}
export interface OnboardingModalidade {
  modalidades: string[];
  slides: SlideOnboarding[];
}

export interface SlideOnboarding {
  cabecalho: {
    titulo: string;
    descricao: string;
  };
  corpo: {
    alt?: string;
    titulo: string;
    descricao: string;
    conteudo: {
      desktop: string;
      mobile: string;
    };
    tipo: 'IMAGEM' | 'YOUTUBE';
  };
}

export interface ConfiguracoesMarca {
  BIBLIOTECA_VIRTUAL: BibliotecaVirtual[];
  CALENDARIO_ACADEMICO: CalendarioAcademico[];
  OPCOES_MENU_AJUDA: Ajuda[];
  MODALIDADES_ELEGIVEIS_AVALIACAO_AURA: string[];
  MODALIDADES_ELEGIVEIS_EXERCICIOS: string[];
  DISCIPLINAS_ELEGIVEIS_EXERCICIOS: string[];
  DISCIPLINAS_ELEGIVEIS_MAPEAMENTO_COMPETENCIAS: string[];
  URL_BDQ_ALUNO: string; // gamb
  URL_BDQ_EDUCADOR: string; // gamb
  URL_TERMS: string;
  BANNERS_COMUNICACAO: BannerComunicacao[];
  ONBOARDING: Onboarding[];
  URL_CRIATIVA_HUMANA: string;
  URL_CAMPUS_SIA: string;
  TURMAS_MVP_SIRIUS?: string[];
  HABILITAR_CURSOS_COMPLEMENTARES: boolean;
  CURSOS_LIVRES?: CursosLivres;
  HABILITAR_CURSOS_LIVRES: boolean;
}

export interface Configuracao {
  titulo: string;
  url: string;
}

export interface BibliotecaVirtualService extends Configuracao {
  descricao: string;
}

//???? baguncinha aqui
export interface OpcoesMenuAjudaService extends Configuracao {
  tagGA: string;
  modalidade?: Modalidade;
  tipo: OpcoesAjuda;
}

export interface ConfiguracoesMarcaPropriedadesEducadoresService {
  bibliotecaVirtual: BibliotecaVirtualService[];
  calendarioAcademico: Configuracao[];
  opcoesMenuAjuda: OpcoesMenuAjudaService[];
  urlBdq: string;
  urlTermos: string;
}

interface BlocklistBanner {
  tiposCursos: string[];
  modalidades: string[];
  codigoCurso: string[];
  periodosAcademicos: string[];
  safras: string[];
}

export interface BannerComunicacao {
  link: string;
  imagem: string;
  dataInicioExibicao: Date;
  dataFimExibicao: Date;
  blocklist: BlocklistBanner | null;
}

export type TipoConteudoOnboarding = 'SLIDE' | 'SLIDE_DASHBOARD';
export type TipoSlide = 'IMAGEM_COM_TEXTO' | 'IMAGEM_COM_LISTA';

export interface ImagemSlide {
  desktop: string;
  mobile: string;
}

export interface Slide {
  interpolacoes: string[];
  tipo: TipoSlide;
  imagem: ImagemSlide;
  titulo: string[]; // quando existir a notação {valor}, ex: {nome} refere-se a interpolações
  subtitulo?: string[];
}

export interface CorpoSlideComTexto extends Slide {
  descricao: string[];
}

export interface SlideItemLista {
  asset: string; // nome do arquivo referente ao ícone do lift ex: lft_checkmark
  texto: string;
  subtexto?: string;
}

export interface CorpoSlideComLista extends Slide {
  subtitulo?: string[];
  itens: SlideItemLista[];
}

export interface Onboarding {
  id: string;
  modalidades: Modalidade[];
  tipoCursos: TipoCurso[];
  tipoConteudo: TipoConteudoOnboarding;
  corpo: CorpoSlideComTexto | CorpoSlideComLista;
}

interface CursosLivres {
  endpoint: string;
  url: string;
}

export interface ConfiguracoesMarcaPropriedadesAlunoService extends ConfiguracoesMarcaPropriedadesEducadoresService {
  modalidadesElegiveisAvaliacaoAura: string[];
  modalidadesElegiveisExercicios: string[];
  disciplinasElegiveisExercicios: string[];
  disciplinasElegiveisMapeamentoCompetencias: string[];
  bannersComunicacao?: BannerComunicacao[];
  onboarding: Onboarding[];
  urlCriativaHumana: string;
  turmasMVPSirius?: string[];
  habilitarCursosComplementares: boolean;
  cursosLivres?: CursosLivres;
  habilitarCursosLivres: boolean;
}

export interface ConfiguracoesMarcaServiceResponse {
  id: string;
  marca: string;
  onboardingPlataforma: OnboardingPlataforma;
  aluno: ConfiguracoesMarcaPropriedadesAlunoService;
  educador: ConfiguracoesMarcaPropriedadesEducadoresService;
  urlCampusSia?: string;
}

export type Fonte = 'arquivo' | 'servico';

export interface Params {
  urlBase: string;
  domain: Domain;
  brand: Brand;
}

export type Service = (props: Params) => Promise<ConfiguracoesMarca>;
